// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LfkCd","title":"styles_title__v4B-c","desc":"styles_desc__wVk-s","price":"styles_price__kJOOS","img":"styles_img__CgDOy"};